import { useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { verifyUserKyc } from '../../../../../app/store/slices/user/user';
import { errorToast, successToastTopRight } from '../../../../../utils/toasts/toasts';

export default function useKycVerification({ onSuccess }) {

    const dispatch = useDispatch();
    const user = useSelector((state) => state.auth.user);

    const [loading, setLoading] = useState(false);

    const initialValues = {
        idProof: '',
        aadharNumber: '',
        isTermsAccepted: false
    };

    const validationSchema = Yup.object({
        idProof: Yup.object().required('ID Proof is required'),
        aadharNumber: Yup.string()
            .matches(/^\d{12}$/, 'Aadhar number must be 12 digits')
            .required('Aadhar number is required'),
        isTermsAccepted: Yup.bool().oneOf([true], 'You must accept the terms and conditions')
    });

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: async (values) => {
            try {
                setLoading(true);

                const payload = {
                    user_id: user.id,
                    aadhar_number: values.aadharNumber,
                }

                const response = await dispatch(verifyUserKyc(payload)).unwrap();

                if (response.code === 200) {
                    successToastTopRight('KYC details submitted successfully. It will be verified shortly.');
                    if (onSuccess) onSuccess();
                }

            } catch (error) {
                switch (error.code) {
                    case 400:
                        errorToast(error.message || 'Bad Request');
                        break;
                    case 404:
                        errorToast(error.message || 'User Not Found');
                        break;
                    case 500:
                        errorToast(error.message || 'Internal Server Error');
                        break;
                    default:
                        errorToast('Something went wrong. Please try again.');
                }
            } finally {
                setLoading(false);
            }
        }
    });

    return {
        idProofOptions,
        formik,
        loading
    };
}

const idProofOptions = [
    { id: 1, name: 'Aadhar Card' }
];